export default {
  TWITTER_COLOR: "rgb(48, 155, 240)",

  // official Wordle colors
  GRAY: "#3a3a3c", // not present tile and disabled keyboard key
  LIGHT_GRAY: "#818384", // keyboard key
  GREEN: "#6aaa64",
  YELLOW: "#c9b458",
  BLACK: "#000000",
  DARK_GRAY: "#3a3a3c",
  WHITE: "#FFFFFF",

  GRAY_BORDER: "#565758",
  INCORRECT_GRAY: "rgb(110, 110, 110)",
};
